export enum ModuleNameEnum {
  DASHBOARD = 'dashboard',
  LOCATIONS = 'locations',
  SPACES = 'spaces',
  BOOKINGS = 'bookings',
  TRANSACTIONS = 'transactions',
  CLASSES = 'classes',
  CUSTOMERS = 'customers',
  CUSTOMER_GROUPS = 'customer_groups',
  AUTHENTICATION_ACL = 'authentication_acl',
  SETTINGS = 'settings',
  BANNERS = 'banners',
  CAMPAIGNS = 'campaigns',
  TOURNAMENTS = 'tournaments',
  TRIPS = 'trips',
  ADDONS = 'addons',
}
